import { render, staticRenderFns } from "./PremiumListing.vue?vue&type=template&id=abec235e"
import script from "./PremiumListing.vue?vue&type=script&lang=js"
export * from "./PremiumListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports